import { Divider, Popover } from "antd";
import Logined from "@/app/assets/user/Logined.svg";
import userInfoStore from "@/store/userInfoStore";
import { useRouter } from "next/navigation";
import shopCartStore from "@/store/shopCartStore";
import { logout } from "@/service/user";

export type PersonalInfoProps = {
  children: React.ReactNode;
};

export const PersonalInfo: React.FC<PersonalInfoProps> = ({
  children,
  ...props
}) => {
  const router = useRouter();
  const { userInfo, removeUserInfo } = userInfoStore();
  const { removeShopCart } = shopCartStore();

  /**
   * 退出登录
   */
  const handleSignOut = async () => {
    const { status, data } = await logout();
    if (status == 200) {
      removeUserInfo();
      removeShopCart();
      onLogout();
    }
  };

  const onLogout = () => {
    // 清除 user_id
    // @ts-ignore
    window.gtag('set', 'user_id', null);

    // 可以选择发送一个注销事件
    // @ts-ignore
    window.gtag('event', 'logout');
  }

  const content = (
    <div className="w-235 px-8 py-11 lg:w-280">
      <div className="flex items-center">
        <div className="flex h-42 w-42 items-center justify-center rounded-[50%] bg-bravve-line-100 leading-[4.2rem]">
          <Logined width={24} stroke={"#fff"} stroke-width="1.5" />
        </div>
        <span className="mx-12 text-xl font-bold leading-26 text-bravve-100 lg:text-2xl lg:leading-28">
          {userInfo?.email}
        </span>
      </div>
      <div>
        <div
          className="mt-20 flex hover:cursor-pointer"
          onClick={() => {
            router.push("/orders");
          }}
        >
          <iconpark-icon
            size="2.2rem"
            name="Order"
            icon-id="Order"
            stroke="#402C22"
          />
          <span className="ml-12 leading-22 text-bravve-100 lg:text-lg lg:leading-24">
            My Orders
          </span>
        </div>

        <Divider style={{ margin: "20px 0" }} />

        <div
          className="flex hover:cursor-pointer"
          onClick={() => {
            handleSignOut();
          }}
        >
          <iconpark-icon
            size="2.2rem"
            name="quit"
            icon-id="quit"
            stroke="#402C22"
          />
          <span className="ml-12 leading-22 text-bravve-100 lg:text-lg lg:leading-24">
            Sign Out
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <Popover
      placement="bottomRight"
      content={content}
      overlayInnerStyle={{ marginTop: 8, border: "1px solid #C6C0BD" }}
      arrow={false}
    >
      {children}
    </Popover>
  );
};
